import { CaseGranulometry } from '../../CaseGranulometry';
import { FacadeSpecification } from '../../../../../services/mapBox/domain/facades/FacadeSpecification';
import { getCaseGroundLevel } from '../levels/getCaseGroundLevel';

export const getCaseGroundLevelGeometryFacades = (
  caseGranulometry: CaseGranulometry
): FacadeSpecification[] | undefined =>
  getCaseGroundLevel(caseGranulometry).geometry?.properties?.facades;
